import { assign, createMachine } from "xstate"

const initialContext = {
  addGastoSucces: false,
  alumnos: [],
  conceptosGasto: [],
  dataArmarReciboPago: {},
  descuentosCatalogo: [],
  descuentosxidCuenta: [],
  error: "",
  estadoCuenta: { Cuentas: [{ lista_cargos: [] }] },
  formasPagoSAT: [],
  gastoIsLoading: false,
  gasto: {},
  gastos: [],
  grupoServiciosEquivalentes: [],
  id_Recibo_Pago: -1,
  id_Relacion_Cuenta_Cargo: -1,
  idAlumno: -1,
  isProcessingDeloCargo: false,
  loading: false,
  mensajeExitoso: "",
  oAlumno: {},
  oCargoIsLoading: false,
  oRecibo: {},
  oUltimoCargo: { Cantidad: 0 },
  rowsAffectedDelIdRelDescCargo: 0,
  rowsAffectedDeloCargo: 0,
  servicios: [],
  usosCFDI40: [],
}

const cajaMachine = createMachine(
  {
    predictableActionArguments: true,
    context: initialContext,
    id: "caja",
    initial: "idle",
    states: {
      idle: {
        on: {
          "caja/GASTO": {
            actions: ["unsetError", "unsetGasto", "setGastoIsLoading"],
            target: "idle",
          },
          "caja/GASTO_SUCCESS": {
            actions: ["unsetError", "setGasto", "unsetGastoIsLoading"],
            target: "idle",
          },
          "caja/GASTO_FAIL": {
            actions: ["setError", "unsetGastoIsLoading"],
            target: "idle",
          },

          "caja/DELGASTO": {
            actions: ["unsetError", "setGastoIsLoading"],
            target: "idle",
          },
          "caja/DELGASTO_SUCCESS": {
            actions: ["unsetError", "unsetGastoIsLoading"],
            target: "idle",
          },
          "caja/DELGASTO_FAIL": {
            actions: ["setError", "unsetGastoIsLoading"],
            target: "idle",
          },

          "caja/GASTOS": {
            actions: ["unsetError", "unsetGastos", "setGastoIsLoading"],
            target: "idle",
          },
          "caja/GASTOS_SUCCESS": {
            actions: [
              "unsetError",
              "setGastos",
              "setConceptosGasto",
              "unsetGastoIsLoading",
            ],
            target: "idle",
          },
          "caja/GASTOS_FAIL": {
            actions: ["setError", "unsetGastoIsLoading"],
            target: "idle",
          },

          "caja/LINKPAGO": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/LINKPAGO_SUCCESS": {
            actions: ["unsetError", "unsetLoading"],
            target: "idle",
          },
          "caja/LINKPAGO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/LINKPAGO_MASIVO": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/LINKPAGO_MASIVO_SUCCESS": {
            actions: ["unsetError", "unsetLoading"],
            target: "idle",
          },
          "caja/LINKPAGO_MASIVO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },

          "caja/SET_MESSAGE_SUCCESS": {
            actions: ["setMensajeExitoso"],
            target: "idle",
          },
          "caja/UNSET_MESSAGE_SUCCESS": {
            actions: ["unsetMensajeExitoso"],
            target: "idle",
          },
          "caja/ADDGASTO": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/ADDGASTO_SUCCESS": {
            actions: ["unsetError", "setAddGastoSucces", "unsetLoading"],
            target: "idle",
          },
          "caja/ADDGASTO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/CONCEPTOSGASTO": {
            actions: ["unsetError", "setGastoIsLoading"],
            target: "idle",
          },
          "caja/CONCEPTOSGASTO_SUCCESS": {
            actions: ["unsetError", "setConceptosGasto", "unsetGastoIsLoading"],
            target: "idle",
          },
          "caja/CONCEPTOSGASTO_FAIL": {
            actions: ["setError", "unsetGastoIsLoading"],
            target: "idle",
          },
          "caja/DEL_OCARGO": {
            actions: ["unsetError", "setIsProcessingDeloCargo"],
            target: "idle",
          },
          "caja/DEL_OCARGO_SUCCESS": {
            actions: [
              "unsetError",
              "setRowsAffectedDeloCargo",
              "unsetIsProcessingDeloCargo",
            ],
            target: "idle",
          },
          "caja/DEL_OCARGO_FAIL": {
            actions: ["setError", "unsetIsProcessingDeloCargo"],
            target: "idle",
          },
          "caja/ADDCARGO": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/ADDCARGO_SUCCESS": {
            actions: [
              "unsetError",
              "set_id_Relacion_Cuenta_Cargo",
              "unsetLoading",
            ],
            target: "idle",
          },
          "caja/ADDCARGO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/DEL_IDRELACIONDESCUENTOCARGO": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/DEL_IDRELACIONDESCUENTOCARGO_SUCCESS": {
            actions: [
              "unsetError",
              "setRowsAffectedDelIdRelDescCargo",
              "unsetLoading",
            ],
            target: "idle",
          },
          "caja/DEL_IDRELACIONDESCUENTOCARGO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/SET_OALUMNOSELECTED": {
            actions: ["unsetError", "set_oAlumno_Selected"],
            target: "idle",
          },
          "caja/SET_IDALUMNOSELECTED": {
            actions: ["unsetError", "set_id_Alumno_Selected"],
            target: "idle",
          },
          "caja/ULTIMOCARGO": {
            actions: ["unsetError", "setoCargoIsLoading"],
            target: "idle",
          },
          "caja/ULTIMOCARGO_SUCCESS": {
            actions: ["unsetError", "setoUltimoCargo", "unsetoCargoIsLoading"],
            target: "idle",
          },
          "caja/ULTIMOCARGO_FAIL": {
            actions: ["setError", "unsetoCargoIsLoading"],
            target: "idle",
          },

          "caja/SERVICIOS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/SERVICIOS_SUCCESS": {
            actions: ["unsetError", "setServicios", "unsetLoading"],
            target: "idle",
          },
          "caja/SERVICIOS_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/LOGOUT": {
            actions: ["resetMachine"],
            target: "idle",
          },
          "caja/ALUMNOS": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/ALUMNOS_SUCCESS": {
            actions: ["unsetError", "setAlumnos", "unsetLoading"],
            target: "idle",
          },
          "caja/ALUMNOS_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/ABONOACUENTA": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/ABONOACUENTA_SUCCESS": {
            actions: ["unsetError", "set_id_Recibo_Pago", "unsetLoading"],
            target: "estadoRecibo",
          },
          "caja/ABONOACUENTA_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/ESTADOCUENTA": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/ESTADOCUENTA_SUCCESS": {
            actions: ["unsetError", "setEstadoCuenta", "unsetLoading"],
            target: "idle",
          },
          "caja/ESTADOCUENTA_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/GETDESCUENTOSCATALOGO": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/GETDESCUENTOSCATALOGO_SUCCESS": {
            actions: ["unsetError", "setDescuentosCatalogo", "unsetLoading"],
            target: "idle",
          },
          "caja/GETDESCUENTOSCATALOGO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
          "caja/GETDESCUENTOSXIDCUENTA": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/GETDESCUENTOSXIDCUENTA_SUCCESS": {
            actions: ["unsetError", "setDescuentosxidCuenta", "unsetLoading"],
            target: "idle",
          },
          "caja/GETDESCUENTOSXIDCUENTA_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },

          "caja/GSEQUIVALENTES": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/GSEQUIVALENTES_SUCCESS": {
            actions: ["unsetError", "setGSEquivalentes", "unsetLoading"],
            target: "idle",
          },
          "caja/GSEQUIVALENTES_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },

          "caja/FORMASPAGOSAT": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/FORMASPAGOSAT_SUCCESS": {
            actions: ["unsetError", "setFormasPagoSAT", "unsetLoading"],
            target: "idle",
          },
          "caja/FORMASPAGOSAT_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },

          "caja/USOSCFDI40": {
            actions: ["unsetError", "setLoading"],
            target: "idle",
          },
          "caja/USOSCFDI40_SUCCESS": {
            actions: ["unsetError", "setUsoCFDI40", "unsetLoading"],
            target: "idle",
          },
          "caja/USOSCFDI40_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "idle",
          },
        },
      },
      estadoRecibo: {
        on: {
          "caja/LOGOUT": {
            actions: ["resetMachine"],
            target: "idle",
          },
          "caja/RECIBOPAGO": {
            actions: ["unsetError", "setLoading"],
            target: "estadoRecibo",
          },
          "caja/RECIBOPAGO_SUCCESS": {
            actions: [
              "unsetError",
              "setdataArmarReciboPago",
              "unsetLoading",
              "unset_id_Recibo_Pago",
              "unsetEstadoCuenta",
            ],
            target: "estadoRecibo",
          },
          "caja/RECIBOPAGO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "estadoRecibo",
          },
          "caja/ENVIORECIBO": {
            actions: ["unsetError", "setLoading"],
            target: "estadoRecibo",
          },
          "caja/ENVIORECIBO_SUCCESS": {
            actions: [
              "unsetError",
              "setMensajeExitoso",
              "unset_id_Recibo_Pago",
              "unsetLoading",
            ],
            target: "idle",
          },
          "caja/ENVIORECIBO_FAIL": {
            actions: ["setError", "unsetLoading"],
            target: "estadoRecibo",
          },
        },
      },
      filtrado: {
        on: {
          CONTROLESCOLAR_UNSETFILTRO: {
            target: "idle",
          },
        },
      },
    },
  },
  {
    actions: {
      resetMachine: assign(initialContext),
      setAddGastoSucces: assign({
        addGastoSucces: true,
      }),
      unsetAddGastoSucces: assign({
        addGastoSucces: false,
      }),
      set_id_Relacion_Cuenta_Cargo: assign({
        id_Relacion_Cuenta_Cargo: (_, event) => {
          return event.payload.id_Relacion_Cuenta_Cargo
        },
      }),
      setRowsAffectedDelIdRelDescCargo: assign({
        rowsAffectedDelIdRelDescCargo: (_, event) => {
          return event.payload.data
        },
      }),
      setRowsAffectedDeloCargo: assign({
        rowsAffectedDeloCargo: (_, event) => {
          return event.payload.data
        },
      }),
      unsetRowsAffectedDelIdRelDescCargo: assign({
        rowsAffectedDelIdRelDescCargo: 0,
      }),
      set_id_Alumno_Selected: assign({
        idAlumno: (_, event) => {
          return event.payload.idAlumno
        },
      }),
      set_oAlumno_Selected: assign({
        oAlumno: (_, event) => event.payload.oAlumno,
      }),
      setNotificacion: assign({
        error: (_, event) => {
          console.log("Caja::setNotificacion")
          return ""
        },
      }),
      setAlumnos: assign({
        alumnos: (_, event) => {
          return event.payload.data
        },
      }),
      setoUltimoCargo: assign({
        oUltimoCargo: (_, event) => {
          return event.payload.data
        },
      }),
      setConceptosGasto: assign({
        conceptosGasto: (_, event) => {
          return event.payload.data
        },
      }),
      setServicios: assign({
        servicios: (_, event) => {
          //console.log("servicios:", event.payload.data)
          return event.payload.data
        },
      }),
      unsetServicios: assign(initialContext.servicios),
      setMensajeExitoso: assign({
        mensajeExitoso: (_, event) => {
          //console.log("setMensajeExitoso:", event.payload)
          return event.payload.mensajeExitoso
        },
      }),
      unsetMensajeExitoso: assign({
        mensajeExitoso: "",
      }),
      setdataArmarReciboPago: assign({
        dataArmarReciboPago: (_, event) => {
          //console.log("setdataArmarReciboPago:", event.payload.data)
          return event.payload.data
        },
      }),
      setoRecibo: assign({
        oRecibo: (_, event) => {
          return event.payload.recibo
        },
      }),
      set_id_Recibo_Pago: assign({
        id_Recibo_Pago: (_, event) => {
          return event.payload.id_Recibo_Pago
        },
      }),
      unset_id_Recibo_Pago: assign({
        id_Recibo_Pago: -1,
      }),
      setEstadoCuenta: assign({
        estadoCuenta: (_, event) => {
          return event.payload.edoCuenta
        },
      }),
      unsetEstadoCuenta: assign({
        estadoCuenta: initialContext.estadoCuenta,
      }),
      setDescuentosCatalogo: assign({
        descuentosCatalogo: (_, event) => {
          return event.payload.descuentosCatalogo
        },
      }),
      setDescuentosxidCuenta: assign({
        descuentosxidCuenta: (_, event) => {
          return event.payload.descuentosxidCuenta
        },
      }),
      setGSEquivalentes: assign({
        grupoServiciosEquivalentes: (_, event) => {
          return event.payload.data
        },
      }),
      setFormasPagoSAT: assign({
        formasPagoSAT: (_, event) => {
          return event.payload.data
        },
      }),
      setUsoCFDI40: assign({
        usosCFDI40: (_, event) => {
          return event.payload.data
        },
      }),
      setError: assign({
        error: (_, event) => {
          console.log(event.payload)
          return event.payload
        },
      }),
      unsetError: assign({
        error: null,
      }),
      setLoading: assign({
        loading: true,
      }),
      unsetLoading: assign({
        loading: false,
      }),
      setoCargoIsLoading: assign({
        oCargoIsLoading: true,
      }),
      unsetoCargoIsLoading: assign({
        oCargoIsLoading: false,
      }),
      setGastoIsLoading: assign({
        gastoIsLoading: true,
      }),
      unsetGastoIsLoading: assign({
        gastoIsLoading: false,
      }),
      setIsProcessingDeloCargo: assign({
        isProcessingDeloCargo: true,
      }),
      unsetIsProcessingDeloCargo: assign({
        isProcessingDeloCargo: false,
      }),
      // setGasto
      setGasto: assign({
        gasto: (_, event) => {
          return event.payload.data
        },
      }),
      // unsetGasto
      unsetGastos: assign({
        gastos: [],
      }),
      // setGastos
      setGastos: assign({
        gastos: (_, event) => {
          return event.payload.data
        },
      }),
      // unsetGastos
      unsetGastos: assign({
        gastos: [],
      }),
    },
  }
)

export default cajaMachine
